/**
 * Flooring Calculator — Wood Floor Store
 * Works with the hybrid main-product section (mp-* IDs).
 * Reads config from window.CALCULATOR_CONFIG set by Liquid.
 * Handles: area input, wastage toggle, qty stepper, delivery dates,
 *          add-to-cart, sample ordering, popups, accordions, range carousel.
 */
(function () {
  'use strict';

  /* ── Helpers ── */
  function r2(n) { return Math.round(n * 100) / 100; }
  var _currencySymbol = '£';            /* default; overridden from CALCULATOR_CONFIG at init */
  function fmt(n) { return _currencySymbol + n.toFixed(2); }
  //'\u00A3' + n.toFixed(2); }
  function debounce(fn, ms) {
    var timer;
    return function () {
      var ctx = this, args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function () { fn.apply(ctx, args); }, ms);
    };
  }

  /* ── Calculator ── */
  function initCalculator() {
    var cfg = window.CALCULATOR_CONFIG;
    /* Liquid only emits CALCULATOR_CONFIG when has_calculator is true
       (valid global.box_size metafield). On non-flooring products the
       calculator block isn't rendered, so we exit cleanly. */
    if (!cfg) return;

    /* ── Variant price-display update (all products, incl. accessories) ──
       Subscribe here — BEFORE the packSize guard — so accessory products
       (packSize = 0) still get live price updates when a variant is picked. */
    if (typeof subscribe === 'function') {
      subscribe('variant-change', function(event) {
        var variant = event && event.data && event.data.variant;
        if (!variant) return;
        var priceDisplayEls = document.querySelectorAll('.mp-price-sale');
        priceDisplayEls.forEach(function(priceDisplayEl) {
          priceDisplayEl.textContent = variant.unit_price ? fmt(variant.unit_price / 100) + ' /m²' : '';
        });
        var compareUnit = cfg.packSize > 0 && variant.compare_at_price > variant.price ? variant.compare_at_price / cfg.packSize : 0;
        document.querySelectorAll('.mp-price-unit-compare').forEach(function(compareDisplayEl) {
          compareDisplayEl.textContent = compareUnit > variant.unit_price ? fmt(compareUnit / 100) + ' /m²' : '';
          compareDisplayEl.style.display = compareUnit > variant.unit_price ? '' : 'none';
        });
      });
    }

    /* Set currency symbol for fmt() — needed by the subscribe callback above */
    _currencySymbol = cfg.currencySymbol || '€';

    /* Calculator requires a valid pack size — accessories skip the rest */
    if (!cfg.packSize || cfg.packSize <= 0) return;

    var areaInput      = document.getElementById('mp-area-input');
    var wastageToggle  = document.getElementById('mp-wastage-toggle');
    var wastageValueEl = document.getElementById('mp-wastage-value');
    var wastageRowEl   = document.getElementById('mp-wastage-desc');
    var qtyInput       = document.getElementById('mp-qty-input');
    var qtyMinus       = document.getElementById('mp-qty-minus');
    var qtyPlus        = document.getElementById('mp-qty-plus');
    var coverageEl     = document.getElementById('mp-coverage');
    var totalPriceEl   = document.getElementById('mp-total-price');
    var savingsRowEl   = document.getElementById('mp-savings-row');
    var savingsEl      = document.getElementById('mp-total-savings');
    var cartQtyInput   = document.getElementById('mp-cart-quantity');
    var deliveryCalcEl = document.getElementById('mp-delivery-calc');
    var deliveryBadge  = document.getElementById('mp-delivery-badge');
    var paypalEl       = document.getElementById('mp-paypal-amount');
    var pricePerM2El   = document.getElementById('mp-price-per-m2');
    var pricePerPackEl = document.getElementById('mp-price-per-pack');
    var packQtyPriceEl = document.getElementById('mp-pack-qty-price');
    var packsCountEl   = document.getElementById('mp-packs-count');

    /* ── Recommended underlay (optional block) ── */
    var underlayEl      = document.getElementById('mp-underlay');
    var underlayCheck   = document.getElementById('mp-underlay-add');
    var underlayCalcEl  = document.getElementById('mp-underlay-calc');
    var underlayRollsEl = document.getElementById('mp-underlay-rolls');
    var underlayTotalEl = document.getElementById('mp-underlay-total');
    var underlayRolls   = 0;
    var underlayLastCoverage = 0;

    function selectedUnderlaySource() {
      if (!underlayEl) return null;
      return underlayEl.querySelector('input[name="mp-underlay-choice"]:checked') || underlayEl;
    }

    function updateUnderlay(coverageM2) {
      if (!underlayEl) return;
      underlayLastCoverage = coverageM2;
      var src = selectedUnderlaySource();
      var rollCoverage = parseFloat(src.getAttribute('data-coverage')) || 0;
      var priceCents   = parseInt(src.getAttribute('data-price-cents'), 10) || 0;
      if (rollCoverage <= 0 || coverageM2 <= 0) {
        underlayRolls = 0;
        if (underlayCalcEl) underlayCalcEl.hidden = true;
        return;
      }
      underlayRolls = Math.ceil(coverageM2 / rollCoverage);
      if (underlayRollsEl) underlayRollsEl.textContent = underlayRolls + (underlayRolls === 1 ? ' roll' : ' rolls');
      if (underlayTotalEl) underlayTotalEl.textContent = '+' + fmt((underlayRolls * priceCents) / 100);
      if (underlayCalcEl) underlayCalcEl.hidden = false;
    }
    if (underlayCheck) {
      underlayCheck.addEventListener('change', function () {
        if (underlayEl) underlayEl.classList.toggle('mp-underlay--active', underlayCheck.checked);
      });
    }
    if (underlayEl) {
      var underlayRadios = underlayEl.querySelectorAll('input[name="mp-underlay-choice"]');
      for (var ur = 0; ur < underlayRadios.length; ur++) {
        underlayRadios[ur].addEventListener('change', function () {
          var opts = underlayEl.querySelectorAll('.mp-underlay__option');
          for (var oi = 0; oi < opts.length; oi++) {
            var radio = opts[oi].querySelector('input[name="mp-underlay-choice"]');
            opts[oi].classList.toggle('is-selected', !!(radio && radio.checked));
          }
          updateUnderlay(underlayLastCoverage);
        });
      }
    }

    if (!areaInput) return;

    var packSize     = cfg.packSize;
    var compareAtPrice = cfg.compareAtPrice || 0;
    var floorPriceLabelEl = document.getElementById('mp-floor-price-label');
    function updateSavings(boxQuantity) {
      if (!savingsRowEl || !savingsEl) return;
      var onSale = compareAtPrice > variantPrice;
      if (floorPriceLabelEl) {
        floorPriceLabelEl.textContent = onSale ? 'Sale Price (VAT incl.):' : 'Floor Price (VAT incl.):';
      }
      var perUnitSaving = onSale ? compareAtPrice - variantPrice : 0;
      var saving = (boxQuantity * perUnitSaving) / 100;
      if (saving > 0) {
        savingsEl.textContent = fmt(saving);
        savingsRowEl.hidden = false;
      } else {
        savingsRowEl.hidden = true;
      }
    }
    var variantPrice = cfg.variantPrice || 0;     /* integer cents per box */
    var unitPrice    = cfg.unitPrice || 0;        /* integer cents per m² */
    var floorStyle   = cfg.floorStyle || '';
    var deliveryDate = cfg.deliveryDate || 'Lead: 5';
    /* Trim each entry — Liquid's `split: ','` keeps the leading space when
       merchants type "2025-05-01, 2025-05-02", which would otherwise never
       match toKey(d) ("YYYY-MM-DD" with no leading space). */
    var blockedDates = (cfg.blockedDates || [])
      .map(function (s) { return (s || '').trim(); })
      .filter(Boolean);
    var formId       = cfg.formId || '';
    var YD2_PER_M2   = 1.196;                     /* 1 m² = 1.196 y² */
    _currencySymbol  = cfg.currencySymbol || '€'; /* read once at init — shop's currency */
    var areaValid    = false;                     /* flipped true once displayVal ≥ 0.01 */
    var qtyManuallySet = false;                   /* true after user types/steps qty directly;
                                                     prevents wastage toggle / unit / variant
                                                     change from clobbering the typed qty.
                                                     Reset when user touches area or W×L. */

    function getWastePct() {
        return (floorStyle.indexOf('Herringbone') !== -1 || floorStyle.indexOf('Chevron') !== -1)
          ? 0.10 : 0.05;
      }

    /* ── Validation ── */
    var areaHint = document.getElementById('mp-area-hint');

    function showHint(msg) { if (areaHint) { areaHint.textContent = msg; areaHint.hidden = false; } }
    function hideHint()    { if (areaHint) { areaHint.textContent = ''; areaHint.hidden = true; } }

    /* ── Core calculation — whole-box pricing ──
         Formula:
           input_m2    = user value converted to m²
           boxes       = ceil(input_m2 / packSize)
           coverage_m2 = boxes × packSize
           total       = boxes × variantPrice / 100
         variantPrice is Shopify's box price; unitPrice is the displayed per-m² rate. */
      function calculateFromArea() {
          var displayVal = parseFloat(areaInput.value) || 0;
          var suf = currentUnit === 'ft' ? 'ft²'
                  : currentUnit === 'yards' ? 'yd²'
                  : 'm²';
          /* Convert typed area directly to m² — the unit pricing/cart work in.
             Unit is treated literally — switching the unit does not re-interpret
             the entered number (live-site parity). */
          var inputM2;
          if (currentUnit === 'ft')         inputM2 = displayVal / SQ_FT_PER_SQ_M;
          else if (currentUnit === 'yards') inputM2 = displayVal / YD2_PER_M2;
          else                              inputM2 = displayVal;
          hideHint();

          if (displayVal < 0.01) {
            /* Empty / near-zero — zero all outputs */
            if (coverageEl)     coverageEl.textContent     = '0.00' + suf;
            if (wastageValueEl) wastageValueEl.textContent  = '0.00' + suf;
            if (wastageRowEl)   wastageRowEl.hidden         = true;
            if (totalPriceEl)   totalPriceEl.textContent    = fmt(0);
            if (paypalEl)       paypalEl.textContent         = fmt(0);
            if (pricePerM2El)   pricePerM2El.textContent    = fmt(0) + '/m²';
            if (pricePerPackEl) pricePerPackEl.textContent   = fmt(0) + '/pack';
          if (packQtyPriceEl) packQtyPriceEl.textContent = '(' + fmt(0) + '/pack)';
            if (packsCountEl)   packsCountEl.textContent     = '0 packs';
            if (qtyInput)       qtyInput.value              = 0;
            if (cartQtyInput)   cartQtyInput.value          = 0;
            updateSavings(0);
            updateUnderlay(0);
            areaValid = false;
            updateButtonState();
            return;
          }
          var incWaste       = wastageToggle ? wastageToggle.checked : false;
          var wastePct       = getWastePct();
          var inputWithWaste = incWaste ? inputM2 * (1 + wastePct) : inputM2;

          /* Round partial boxes up, charge each whole box, and send boxes to cart. */
          /* Tolerance: the area field is rounded to 2dp (e.g. pack 2.3966 shows as
             2.40), so an input within half a cent of a pack multiple must not tip
             the ceil into an extra pack. */
          var boxes         = Math.ceil((inputWithWaste - 0.005) / packSize);
          if (boxes < 1) boxes = 1;
          var coverageM2Raw = boxes * packSize;
          var totalPence    = boxes * variantPrice;
          var total         = totalPence / 100;
          var pricePerM2    = unitPrice / 100;
          var pricePerPack  = variantPrice / 100;

          /* Coverage = purchased area (m²), shown in the user's input unit. */
          var coverageInUnit = currentUnit === 'ft'    ? coverageM2Raw * SQ_FT_PER_SQ_M
                            : currentUnit === 'yards' ? coverageM2Raw * YD2_PER_M2
                            :                           coverageM2Raw;
          coverageInUnit = Math.round(coverageInUnit * 100) / 100;

          /* Wastage row = purchased − requested in the user's input unit (hidden when toggle off). */
          var excessInUnit = Math.round((coverageInUnit - displayVal) * 100) / 100;
          if (excessInUnit < 0) excessInUnit = 0;

          if (coverageEl)     coverageEl.textContent     = coverageInUnit.toFixed(2) + suf;
          if (wastageValueEl) wastageValueEl.textContent  = excessInUnit.toFixed(2) + suf;
          if (wastageRowEl)   wastageRowEl.hidden         = !incWaste;
          if (totalPriceEl)   totalPriceEl.textContent    = fmt(total);
          if (paypalEl)       paypalEl.textContent         = fmt(r2(total / 3));
          if (pricePerM2El)   pricePerM2El.textContent    = fmt(pricePerM2) + '/m²';
          if (pricePerPackEl) pricePerPackEl.textContent   = fmt(pricePerPack) + '/pack';
          if (packQtyPriceEl) packQtyPriceEl.textContent = '(' + fmt(pricePerPack) + '/pack)';
          if (packsCountEl)   packsCountEl.textContent     = boxes + (boxes === 1 ? ' pack' : ' packs');
          if (qtyInput)       qtyInput.value              = boxes; /* pack count */
          if (cartQtyInput)   cartQtyInput.value          = boxes;

          updateSavings(boxes);
          updateUnderlay(coverageM2Raw);
          areaValid = true;
          updateButtonState();
        }

        /* ── Event listeners (debounced on input, immediate on change/stepper) ── */
      var debouncedCalc = debounce(function () { calculateFromArea(); }, 200);
    areaInput.addEventListener('input', function () {
      qtyManuallySet = false;
      debouncedCalc();
    });
    areaInput.addEventListener('change', function () {
      qtyManuallySet = false;
      calculateFromArea();
    });
    if (wastageToggle) wastageToggle.addEventListener('change', function () {
      /* In qty-manual mode, calculateFromArea() would clobber the user's qty.
         Apply the wastage as a delta on the current qty instead, so price,
         coverage, and pack count all bump too. Multiply on / divide off keeps
         it reversible (within ±1 yd² rounding drift on small qtys). */
      if (qtyManuallySet) {
        var v = parseInt(qtyInput ? qtyInput.value : (cartQtyInput && cartQtyInput.value), 10);
        if (isNaN(v) || v < 1) v = 1;
        var pct = getWastePct();
          var prevQty = v;
          var nextQty = wastageToggle.checked
            ? Math.ceil(v * (1 + pct))
            : Math.floor(v / (1 + pct));
          if (nextQty < 1) nextQty = 1;
          applyQty(nextQty);

          if (wastageToggle.checked && wastageValueEl) {
            var suf = currentUnit === 'ft' ? 'ft²' : currentUnit === 'yards' ? 'yd²' : 'm²';
            var wasteExtraPacks = nextQty - prevQty;
            var wasteM2 = wasteExtraPacks * packSize;
            var wasteInUnit = currentUnit === 'ft'    ? wasteM2 * SQ_FT_PER_SQ_M
                            : currentUnit === 'yards' ? wasteM2 * YD2_PER_M2
                            :                           wasteM2;
            wasteInUnit = Math.round(wasteInUnit * 100) / 100;
            wastageValueEl.textContent = wasteInUnit.toFixed(2) + suf;
          }
          if (wastageRowEl) wastageRowEl.hidden = !wastageToggle.checked;
        return;
      }
      calculateFromArea();
    });

    /* Apply a whole-box quantity and refresh the summary and cart quantity. */
    function applyQty(newPacks) {
          if (isNaN(newPacks) || newPacks < 1) newPacks = 1;
          newPacks = Math.floor(newPacks);

          var coverageM2 = newPacks * packSize;

          var total        = (newPacks * variantPrice) / 100;
          var pricePerM2   = unitPrice / 100;
          var pricePerPack = variantPrice / 100;

          var coverageInUnit = currentUnit === 'ft'    ? coverageM2 * SQ_FT_PER_SQ_M
                            : currentUnit === 'yards' ? coverageM2 * YD2_PER_M2
                            :                           coverageM2;
          coverageInUnit = Math.round(coverageInUnit * 100) / 100;
          var suf = currentUnit === 'ft' ? 'ft²' : currentUnit === 'yards' ? 'yd²' : 'm²';

          /* Reflect qty back into the Floor Area input so it stays in sync.
             qty is now a pack count; area is purchased coverage in the active
             display unit. Programmatic .value assignment doesn't trigger 'input'
             events, so this won't recurse. */
          if (areaInput) areaInput.value = r2(coverageInUnit).toFixed(2);

          if (qtyInput)       qtyInput.value           = newPacks;
          if (cartQtyInput)   cartQtyInput.value       = newPacks;
          if (totalPriceEl)   totalPriceEl.textContent = fmt(total);
          if (paypalEl)       paypalEl.textContent     = fmt(r2(total / 3));
          if (pricePerM2El)   pricePerM2El.textContent  = fmt(pricePerM2) + '/m²';
          if (pricePerPackEl) pricePerPackEl.textContent = fmt(pricePerPack) + '/pack';
          if (packQtyPriceEl) packQtyPriceEl.textContent = '(' + fmt(pricePerPack) + '/pack)';
          if (packsCountEl)   packsCountEl.textContent  = newPacks + (newPacks === 1 ? ' pack' : ' packs');
          if (coverageEl)     coverageEl.textContent    = coverageInUnit.toFixed(2) + suf;

          updateSavings(newPacks);
          updateUnderlay(coverageM2);
          areaValid = true;
          updateButtonState();
        }

        function stepQty(delta) {
      var v = parseInt(qtyInput ? qtyInput.value : (cartQtyInput && cartQtyInput.value), 10);
      if (isNaN(v) || v < 1) v = 1;
      qtyManuallySet = true;
      applyQty(v + delta);
    }
    if (qtyPlus)  qtyPlus.addEventListener('click',  function () { stepQty(+1); });
    if (qtyMinus) qtyMinus.addEventListener('click', function () { stepQty(-1); });
    if (qtyInput) qtyInput.addEventListener('input', function () {
      var v = parseInt(qtyInput.value, 10);
      if (!isNaN(v)) {
        qtyManuallySet = true;
        applyQty(v);
      }
    });
    if (qtyInput) qtyInput.addEventListener('change', function () {
      var v = parseInt(qtyInput.value, 10);
      if (isNaN(v) || v < 1) v = 1;
      qtyManuallySet = true;
      applyQty(v);
    });
    if (qtyInput) { qtyInput.step = 1; qtyInput.min = 1; }

    /* Re-render the SUMMARY in the active mode. Use this whenever an external
       event (variant change, unit change) needs to refresh values without
       caring whether the user is in area-driven or qty-driven mode. */
    function refresh() {
      if (qtyManuallySet) {
        var v = parseInt(qtyInput ? qtyInput.value : (cartQtyInput && cartQtyInput.value), 10);
        if (isNaN(v) || v < 1) v = 1;
        applyQty(v);
      } else {
        calculateFromArea();
      }
    }

    /* ── W × L mode ── */
    var calcWrapper  = areaInput.closest('.mp-calc');
    var inputAreaDiv = document.getElementById('mp-input-area');
    var inputWxlDiv  = document.getElementById('mp-input-wxl');
    var widthInput   = document.getElementById('mp-width-input');
    var lengthInput  = document.getElementById('mp-length-input');
    var modeBtns     = calcWrapper ? calcWrapper.querySelectorAll('.mp-mode-btn') : [];

    function setMode(mode) {
      if (!inputAreaDiv || !inputWxlDiv) return;
      calcWrapper.setAttribute('data-input-mode', mode);
      if (mode === 'wxl') {
        inputAreaDiv.hidden = true;
        inputWxlDiv.hidden = false;
        if (widthInput) widthInput.value = '';
        if (lengthInput) lengthInput.value = '';
      } else {
        inputAreaDiv.hidden = false;
        inputWxlDiv.hidden = true;
      }
      for (var i = 0; i < modeBtns.length; i++) {
        modeBtns[i].classList.toggle('mp-mode-btn--active', modeBtns[i].getAttribute('data-mode') === mode);
      }
    }

    for (var mi = 0; mi < modeBtns.length; mi++) {
      modeBtns[mi].addEventListener('click', function () {
        setMode(this.getAttribute('data-mode'));
      });
    }

    function onWxlInput() {
      var w = parseFloat(widthInput ? widthInput.value : 0);
      var l = parseFloat(lengthInput ? lengthInput.value : 0);
      if (!(w > 0)) w = 0;
      if (!(l > 0)) l = 0;
      if (w > 0 && l > 0) {
        /* Live parity: ceil(W × L) as integer in the user's CURRENT unit, BEFORE m² conversion. */
        areaInput.value = Math.ceil(w * l);
      } else {
        /* Either dimension missing → clear area so summary resets to zero */
        areaInput.value = '';
      }
      qtyManuallySet = false;
      calculateFromArea();
    }

    if (widthInput && lengthInput) {
      var debouncedWxl = debounce(onWxlInput, 200);
      widthInput.addEventListener('input', debouncedWxl);
      lengthInput.addEventListener('input', debouncedWxl);
      widthInput.addEventListener('change', onWxlInput);
      lengthInput.addEventListener('change', onWxlInput);
    }

    /* ── Unit selector (m / ft / yards) ── */
    var SQ_FT_PER_SQ_M = 10.764;                  /* 1 m² = 10.764 ft² (verbatim per live spec) */
    var unitSelect = document.getElementById('mp-unit');
    /* When the unit switch is disabled in theme settings the calculator runs in yd²
       (cfg.defaultUnit is set to 'yards' from Liquid). Falls back to 'm' for safety. */
    var currentUnit = cfg.defaultUnit || 'm';

    function unitAriaLabel(u) {
      return 'Floor area in square ' + (u === 'ft' ? 'feet' : u === 'yards' ? 'yards' : 'metres');
    }
    function unitPlaceholder(u) {
      return '0';
    }
function unitShortLabel(u) {
      return u === 'ft' ? 'ft' : u === 'yards' ? 'yd' : 'm';
    }
    function syncUnitLabels(u) {
      var short = unitShortLabel(u);
      var areaLabelEl = document.getElementById('mp-area-unit-label');
      if (areaLabelEl) areaLabelEl.textContent = short;
      var wxlLabelEl = document.getElementById('mp-wxl-unit-label');
      if (wxlLabelEl) wxlLabelEl.textContent = short;
      var suffixEl = document.getElementById('mp-area-suffix');
      if (suffixEl) suffixEl.textContent = short + '\u00B2';
    }


    /* Apply unit-driven attributes at init — the dropdown's change handler
       only fires when the user picks a unit, so non-default starts need this. */
    areaInput.setAttribute('aria-label', unitAriaLabel(currentUnit));
    areaInput.setAttribute('placeholder', unitPlaceholder(currentUnit));
    if (calcWrapper) calcWrapper.setAttribute('data-unit', currentUnit);
    syncUnitLabels(currentUnit);

    if (unitSelect) {
      unitSelect.value = currentUnit;
      unitSelect.addEventListener('change', function () {
        /* Live parity: unit change updates placeholder/aria and re-runs calc, but does NOT
           re-interpret the typed number — 30 typed as m² becomes 30 ft² after switching.
           refresh() preserves a manually-typed qty (just refreshes coverage in the new unit). */
        currentUnit = unitSelect.value;
        areaInput.setAttribute('aria-label', unitAriaLabel(currentUnit));
        areaInput.setAttribute('placeholder', unitPlaceholder(currentUnit));
        if (calcWrapper) calcWrapper.setAttribute('data-unit', currentUnit);
        syncUnitLabels(currentUnit);
        refresh();
      });
    }

    /* ── Initialise ── */
    /* Seed the area input with one pack's worth, expressed in the active unit. */
    areaInput.value = '';
    if (wastageToggle) wastageToggle.checked = false;
    calculateFromArea();

    /* ── Analytics events ── */
    var analyticsTimer = null;
    function fireCalcUpdate() {
      clearTimeout(analyticsTimer);
      analyticsTimer = setTimeout(function () {
        var area = parseFloat(areaInput.value) || 0;
        var qty = parseInt(cartQtyInput ? cartQtyInput.value : 1, 10) || 1;
        document.dispatchEvent(new CustomEvent('fst:calc-update', {
          detail: {
            area: area,
            qty: qty,
            totalPrice: totalPriceEl ? totalPriceEl.textContent : '',
            wastageOn: wastageToggle ? wastageToggle.checked : false,
            mode: calcWrapper ? calcWrapper.getAttribute('data-input-mode') : 'area',
            unit: currentUnit,
            productId: cfg.sectionId
          }
        }));
      }, 1000);
    }

    /* Hook analytics to calc updates */
    var _origCalc = calculateFromArea;
    calculateFromArea = function (updateQty) {
      _origCalc(updateQty);
      fireCalcUpdate();
    };

    /* ── Delivery date computation ── */
    function addBizDays(d, n) {
      var result = new Date(d);
      while (n > 0) {
        result.setDate(result.getDate() + 1);
        var day = result.getDay();
        if (day !== 0 && day !== 6) n--;
      }
      return result;
    }

    function toKey(d) {
      return d.getFullYear() + '-' +
        String(d.getMonth() + 1).padStart(2, '0') + '-' +
        String(d.getDate()).padStart(2, '0');
    }

    function nextAvail(d) {
      while (blockedDates.indexOf(toKey(d)) !== -1) d = addBizDays(d, 1);
      return d;
    }

    function computeDate(str) {
      var now = new Date();
      var opts = { weekday: 'long', day: 'numeric', month: 'long' };
      if (!str) return '';
      var s = str.trim();
      if (s.indexOf('Lead:') === 0) {
        var lead = parseInt(s.replace('Lead:', '').trim(), 10);
        if (isNaN(lead)) return '';
        return nextAvail(addBizDays(now, lead)).toLocaleDateString(undefined, opts);
      }
      if (s.indexOf('Delay:') === 0) {
        var d = new Date(s.replace('Delay:', '').trim());
        if (isNaN(d.getTime())) return '';
        return nextAvail(d).toLocaleDateString(undefined, opts);
      }
      if (s === 'NextDay') {
        return nextAvail(addBizDays(now, now.getHours() < 12 ? 1 : 2)).toLocaleDateString(undefined, opts);
      }
      return '';
    }

    var dateDisplay = computeDate(deliveryDate);

    if (deliveryCalcEl && dateDisplay) {
      deliveryCalcEl.innerHTML = 'Delivery available from <strong>' + dateDisplay + '</strong> or free storage for 6 months';
    }

    if (deliveryBadge && dateDisplay) {
      var parts = dateDisplay.split(' ');
      var dateStr = '';
      for (var i = 0; i < parts.length; i++) {
        var p = parts[i].replace(',', '');
        if (!isNaN(parseInt(p, 10)) || /^[A-Za-z]/.test(p)) dateStr += p + ' ';
      }
      deliveryBadge.textContent = 'DELIVERY FROM ' + dateStr.trim().toUpperCase();
      deliveryBadge.style.display = 'inline-block';
    }

    /* ── Helper: get Dawn cart-drawer sections for re-render ── */
    function getDrawerSections() {
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.getSectionsToRender === 'function') {
        return drawer.getSectionsToRender().map(function (s) { return s.id; });
      }
      return [];
    }

    /* ── Helper: update Dawn cart drawer with response sections ── */
    function updateCartDrawer(response, triggerEl) {
      var drawer = document.querySelector('cart-drawer');
      if (!drawer || !response.sections) return;

      /*
       * Dawn's getSectionsToRender returns objects like:
       *   { id: 'cart-drawer', selector: '#CartDrawer' }
       *   { id: 'cart-icon-bubble' }
       * - 'id' = the section ID used as key in response.sections
       * - 'selector' = CSS selector for the DOM element to update
       *   (if absent, falls back to #id)
       * We must use getSectionInnerHTML which parses with the selector.
       */
      drawer.getSectionsToRender().forEach(function (section) {
        var sectionHtml = response.sections[section.id];
        if (!sectionHtml) return;

        var targetEl = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);
        if (!targetEl) return;

        /* Use Dawn's own parsing approach: querySelector with selector or .shopify-section fallback */
        var parsedSelector = section.selector || '.shopify-section';
        var parsed = new DOMParser().parseFromString(sectionHtml, 'text/html');
        var newContent = parsed.querySelector(parsedSelector);
        if (newContent) {
          targetEl.innerHTML = newContent.innerHTML;
          document.querySelector('cart-drawer.drawer').classList.remove('is-empty');
        }
      });

      /* Re-bind overlay click and open drawer */
      setTimeout(function () {
        var overlay = drawer.querySelector('#CartDrawer-Overlay');
        if (overlay) overlay.addEventListener('click', function () { drawer.close(); });
        if (typeof drawer.open === 'function') drawer.open(triggerEl);
      });
    }

    /* ── Sold-out / availability state ── */
    var atcBtn = document.getElementById('mp-atc-btn');
    var variantAvailable = true;

    function updateAtcState(available) {
      variantAvailable = !!available;
      updateButtonState();
    }

    /* Unified button state — considers both variant availability and area validity. */
    function updateButtonState() {
      if (!atcBtn) return;
      if (!variantAvailable) {
        atcBtn.disabled = true;
        atcBtn.textContent = atcBtn.getAttribute('data-sold-out') || 'Sold out';
        atcBtn.classList.add('mp-atc--sold-out');
      } else if (!areaValid) {
        atcBtn.disabled = true;
        atcBtn.textContent = atcBtn.getAttribute('data-empty') || 'Enter floor area';
        atcBtn.classList.remove('mp-atc--sold-out');
      } else {
        atcBtn.disabled = false;
        atcBtn.textContent = atcBtn.getAttribute('data-label') || 'ADD TO CART';
        atcBtn.classList.remove('mp-atc--sold-out');
      }
    }

    /* ── Error toast ── */
    var atcErrorEl = document.getElementById('mp-atc-error');
    var atcErrorMsg = document.getElementById('mp-atc-error-msg');
    var atcErrorTimer = null;

    function showAtcError(msg) {
      if (!atcErrorEl || !atcErrorMsg) return;
      atcErrorMsg.textContent = msg || 'Something went wrong. Please try again.';
      atcErrorEl.hidden = false;
      clearTimeout(atcErrorTimer);
      atcErrorTimer = setTimeout(function () { hideAtcError(); }, 6000);
    }
    function hideAtcError() {
      if (atcErrorEl) atcErrorEl.hidden = true;
      clearTimeout(atcErrorTimer);
    }
    if (atcErrorEl) {
      var closeBtn = atcErrorEl.querySelector('.mp-atc-error__close');
      if (closeBtn) closeBtn.addEventListener('click', hideAtcError);
    }

    /* ── Add to Cart ── */
    if (atcBtn) {
      atcBtn.addEventListener('click', function () {
        hideAtcError();
        var form = document.getElementById(formId);
        var varInput = form ? form.querySelector('input.product-variant-id') : null;
        if (!varInput || !varInput.value) return;

        var qty = parseFloat(cartQtyInput ? cartQtyInput.value : qtyInput.value) || 1;
        atcBtn.disabled = true;
        atcBtn.textContent = 'Adding\u2026';

        var sectionsToFetch = getDrawerSections();
        var atcItems = [{ id: parseInt(varInput.value, 10), quantity: qty }];
        if (underlayEl && underlayCheck && underlayCheck.checked && underlayRolls > 0) {
          var underlaySrc = selectedUnderlaySource();
          var underlayVid = parseInt(underlaySrc.getAttribute('data-variant-id'), 10);
          if (underlayVid) atcItems.push({ id: underlayVid, quantity: underlayRolls });
        }
        var bodyData = {
          items: atcItems
        };
        if (sectionsToFetch.length > 0) {
          bodyData.sections = sectionsToFetch;
          bodyData.sections_url = window.location.pathname;
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(bodyData)
        })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (err) { throw err; });
          return r.json();
        })
        .then(function (response) {
          atcBtn.disabled = false;
          atcBtn.textContent = atcBtn.getAttribute('data-label') || 'ADD TO CART';
          document.dispatchEvent(new CustomEvent('fst:calc-atc', { detail: { qty: qty, variantId: parseInt(varInput.value, 10) } }));
          var upsellPopup = document.getElementById('upsell-popup-overlay');
          if (upsellPopup) {
            document.dispatchEvent(new CustomEvent('fst:open-upsell-popup', { detail: { qty: qty } }));
          } else {
            updateCartDrawer(response, atcBtn);
          }
        })
        .catch(function (err) {
          atcBtn.disabled = false;
          atcBtn.textContent = atcBtn.getAttribute('data-label') || 'ADD TO CART';
          var msg = (err && err.description) || (err && err.message) || '';
          if (err && err.status === 429) msg = 'Too many requests \u2014 try again in a few seconds. ' + msg;
          showAtcError(msg);
          document.dispatchEvent(new CustomEvent('fst:calc-atc-error', { detail: { error: msg } }));
        });
      });
    }

    /* ── Sample button ── */
    var sampleBtn = document.getElementById('mp-sample-btn');
    if (sampleBtn) {
      sampleBtn.addEventListener('click', function () {
        hideAtcError();
        var vid = sampleBtn.getAttribute('data-variant-id');
        var name = sampleBtn.getAttribute('data-product-name');
        if (!vid) return;
        sampleBtn.disabled = true;
        sampleBtn.textContent = 'Processing\u2026';

        var sectionsToFetch = getDrawerSections();
        var bodyData = {
          items: [{ id: parseInt(vid, 10), quantity: 1, properties: { 'Sample For': name, '_sample_product': 'true' } }]
        };
        if (sectionsToFetch.length > 0) {
          bodyData.sections = sectionsToFetch;
          bodyData.sections_url = window.location.pathname;
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(bodyData)
        })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (err) { throw err; });
          return r.json();
        })
        .then(function (response) {
          sampleBtn.disabled = false;
          sampleBtn.textContent = 'ORDER A SAMPLE';
          document.dispatchEvent(new CustomEvent('fst:calc-sample', { detail: { variantId: parseInt(vid, 10) } }));
          updateCartDrawer(response, sampleBtn);
        })
        .catch(function (err) {
          sampleBtn.disabled = false;
          sampleBtn.textContent = 'ORDER A SAMPLE';
          var msg = (err && err.description) || (err && err.message) || '';
          if (err && err.status === 429) msg = 'Too many requests \u2014 try again in a few seconds. ' + msg;
          showAtcError(msg);
          document.dispatchEvent(new CustomEvent('fst:calc-atc-error', { detail: { error: msg, source: 'sample' } }));
        });
      });
    }

    /* ── Variant change rebinding ── */
    var variantsMap = {};
    try {
      var variantsJson = document.getElementById('mp-variants-data');
      if (variantsJson) {
        var variantsArr = JSON.parse(variantsJson.textContent);
        for (var vi = 0; vi < variantsArr.length; vi++) {
          variantsMap[variantsArr[vi].id] = variantsArr[vi];
        }
      }
    } catch (e) { /* ignore parse errors */ }

    /* Seed availability from the currently-selected variant. The first
       calculateFromArea() call would otherwise leave variantAvailable=true
       (its default) and re-enable a sold-out ATC button. */
    (function seedAvailability() {
      var form = document.getElementById(formId);
      var varInput = form ? form.querySelector('input.product-variant-id') : null;
      if (!varInput || !varInput.value) return;
      var vid = parseInt(varInput.value, 10);
      var variant = variantsMap[vid];
      if (variant) updateAtcState(variant.available);
    })();

    function onVariantChange() {
      var form = document.getElementById(formId);
      var varInput = form ? form.querySelector('input.product-variant-id') : null;
      if (!varInput || !varInput.value) return;
      var vid = parseInt(varInput.value, 10);
      var variant = variantsMap[vid];
      if (!variant) {
        console.warn('[Flooring Calculator] Variant ' + vid + ' not found in map.');
        return;
      }
      variantPrice = variant.price;
      unitPrice = variant.unit_price || 0;
      compareAtPrice = variant.compare_at_price || 0;
      refresh();
      updateAtcState(variant.available);
      var priceDisplayEls = document.querySelectorAll('.mp-price-sale');
      priceDisplayEls.forEach(function(priceDisplayEl) {
        priceDisplayEl.textContent = variant.unit_price ? fmt(variant.unit_price / 100) + ' /m²' : '';
      });
      var compareUnit = cfg.packSize > 0 && variant.compare_at_price > variant.price ? variant.compare_at_price / cfg.packSize : 0;
      document.querySelectorAll('.mp-price-unit-compare').forEach(function(compareDisplayEl) {
        compareDisplayEl.textContent = compareUnit > variant.unit_price ? fmt(compareUnit / 100) + ' /m²' : '';
        compareDisplayEl.style.display = compareUnit > variant.unit_price ? '' : 'none';
      });
    }

    /* Fallback for pages without product-info.js (variantPrice / calculator refresh) */
    var picker = document.querySelector('variant-radios, variant-selects');
    if (picker) picker.addEventListener('change', function() {
      var form = document.getElementById(formId);
      var varInput = form ? form.querySelector('input.product-variant-id') : null;
      if (!varInput) return;
      var vid = parseInt(varInput.value, 10);
      var variant = variantsMap[vid];
      if (variant) { variantPrice = variant.price; unitPrice = variant.unit_price || 0; compareAtPrice = variant.compare_at_price || 0; refresh(); updateAtcState(variant.available); }
    });

    /* ── Theme editor reload ── */
    document.addEventListener('shopify:section:load', function () { calculateFromArea(); });

    /* ── Initial state — hits zero-branch when areaInput is empty/0,
       which disables ATC with "Enter floor area" label. ── */
    calculateFromArea();
  }

  /* ── Popups (event delegation + focus trap) ── */
  function initPopups() {
    var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
    var previousFocus = null;

    function openPopup(overlay) {
      previousFocus = document.activeElement;
      overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      var closeBtn = overlay.querySelector('[data-popup-close]');
      if (closeBtn) closeBtn.focus();
    }

    function closePopup(overlay) {
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
      if (previousFocus && typeof previousFocus.focus === 'function') {
        previousFocus.focus();
        previousFocus = null;
      }
    }

    document.addEventListener('click', function (e) {
      /* Open popup */
      var opener = e.target.closest('.mp-open-popup');
      if (opener) {
        var id = opener.getAttribute('data-popup');
        var overlay = document.getElementById(id);
        if (overlay) openPopup(overlay);
        return;
      }
      /* Close popup via button */
      var closer = e.target.closest('[data-popup-close]');
      if (closer) {
        var overlay = closer.closest('.mp-popup-overlay');
        if (overlay) closePopup(overlay);
        return;
      }
      /* Close popup via overlay click */
      if (e.target.classList.contains('mp-popup-overlay')) {
        closePopup(e.target);
      }
    });

    /* Focus trap + Escape */
    document.addEventListener('keydown', function (e) {
      var open = document.querySelector('.mp-popup-overlay.is-open');
      if (!open) return;

      if (e.key === 'Escape') {
        closePopup(open);
        return;
      }

      if (e.key === 'Tab') {
        var focusable = open.querySelectorAll(FOCUSABLE);
        if (focusable.length === 0) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (e.shiftKey) {
          if (document.activeElement === first) { e.preventDefault(); last.focus(); }
        } else {
          if (document.activeElement === last) { e.preventDefault(); first.focus(); }
        }
      }
    });
  }

  /* ── Accordions (event delegation) ── */
  function initAccordions() {
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('.mp-acc__trigger');
      if (!trigger) return;
      var expanded = trigger.getAttribute('aria-expanded') === 'true';
      /* Fix: traverse relative to the clicked trigger instead of using
         getElementById — which always returns the first DOM match (the
         hidden desktop copy), causing mobile accordions to never open.
         We find the .mp-acc__body that is a sibling of this trigger
         inside the same .mp-acc wrapper. */
      var wrapper = trigger.closest('.mp-acc');
      var body = wrapper ? wrapper.querySelector('.mp-acc__body') : null;
      trigger.setAttribute('aria-expanded', String(!expanded));
      if (body) body.classList.toggle('is-open', !expanded);
    });
  }

  /* ── Range carousel ── */
  function initRangeCarousel() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-mp-range-prev], [data-mp-range-next]');
      if (!btn) return;
      var track = btn.closest('.mp-range__wrap').querySelector('.mp-range__track');
      if (!track) return;
      var dir = btn.hasAttribute('data-mp-range-prev') ? -1 : 1;
      track.scrollBy({ left: dir * 192, behavior: 'smooth' });
    });
  }

  /* ── Boot ── */
  function boot() {
    initCalculator();
    initPopups();
    initAccordions();
    initRangeCarousel();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
